import { CoSoRequest } from "../models/request/ky-thi/CoSoRequest";
import { KyThiItemRequest } from "../models/request/ky-thi/KyThiItemRequest";
import { apiClient } from "./apiClient";

export const HINH_THUC_THI_API_END_POINT = "hinh-thuc-thi";

export const hinhThucThiApi = {
  // Get all hinh thuc thi
  selectAll: () => 
    apiClient.get(`${HINH_THUC_THI_API_END_POINT}`)
};
